import type { Page as PageType } from 'src/types/page';
import { ServicePage } from 'src/sections/services/service-page';

const Page: PageType = () => (
  <ServicePage
    seoTitle="Branding & Identity | Mystic Media Film"
    seoDescription="Logos, wordmarks, color systems, and brand guidelines from Mystic Media Film. Houston brand identity work built to carry your message across every surface."
    service="Branding"
    eyebrow="Branding — 2026"
    headline="Identity that"
    accent="signals."
    sub="Logos, wordmarks, color systems, and brand guidelines that tell your story in a single glance."
    description="We build identity systems that carry your message across every surface. |Distinct visual language, documented in one place, made to scale with you."
    deliverables={[
      { num: '01', title: 'Logo & Wordmark', body: 'Primary, secondary, and responsive marks built to work at every size.' },
      { num: '02', title: 'Color System', body: 'Palettes tuned for screen and print, with accessibility built in.' },
      { num: '03', title: 'Typography', body: 'Typeface pairings, hierarchy, and rules for consistent expression.' },
      { num: '04', title: 'Brand Guidelines', body: 'A living doc that shows your team exactly how the brand is used.' },
      { num: '05', title: 'Asset Kit', body: 'Source files, exports, social templates, and launch-ready collateral.' },
      { num: '06', title: 'Strategy', body: 'Positioning, voice, and messaging that anchors every decision.' }
    ]}
    outcomes={['Distinct', 'Consistent', 'Scalable', 'Documented']}
    process={[
      { num: '01', title: 'Discovery', body: 'Positioning workshops, competitor audit, and audience mapping to anchor the work.' },
      { num: '02', title: 'Concepts', body: '2–3 distinct visual directions with rationale — not just options for the sake of options.' },
      { num: '03', title: 'Refinement', body: 'We iterate on the chosen direction until every detail earns its place.' },
      { num: '04', title: 'Delivery', body: 'Final files, brand guidelines, and a launch kit your team can ship with.' }
    ]}
    whyUs={[
      { title: 'Strategy-led, not decoration', body: 'Every mark, color, and typeface ties back to positioning — so the brand earns its keep across every touchpoint.' },
      { title: 'Documented systems', body: 'You leave with a guidelines doc your team actually uses — not a PDF that lives in a folder no one opens.' },
      { title: 'Production-ready', body: 'Every export is sized and formatted for the channels you use — web, print, social, motion, and merch.' }
    ]}
    faqs={[
      { q: 'How long does a brand identity take?', a: '4–6 weeks for a full identity system. Logo-only refreshes can move faster; deeper strategy work runs longer.' },
      { q: 'Do you handle logos only?', a: 'We can — but most clients benefit from the full system. A logo without color, type, and voice rarely holds up in the wild.' },
      { q: 'What if I already have a logo?', a: 'No problem. We can build the system around it, refresh it, or audit whether it still serves where you are headed.' },
      { q: 'Do you write brand voice?', a: 'Yes. Voice, tone, messaging pillars, and tagline work are part of the strategy phase when you opt in.' },
      { q: 'Will my team know how to use the brand?', a: 'Every project ships with guidelines and a kit. We also run a live handoff session so your team owns the system.' },
      { q: 'Can you handle launch collateral?', a: 'Yes — pitch decks, business cards, signage, social templates, and launch announcements are all on the table.' }
    ]}
  />
);

export default Page;
